import { CurrentPmuApplicationUserDetails } from './types';
import { useAuthenticatedCurrentUser } from '@eogile/agrements-common/src/security/CurrentUserContext';

export const usePmuAuthenticatedCurrentUser = () => {
  return useAuthenticatedCurrentUser<CurrentPmuApplicationUserDetails>();
};
